import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import axios from 'axios';
import { useToast } from '../hooks/use-toast';
import '../styles/login.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LoginModal = ({ onClose, onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        password: password
      });

      // Save token to localStorage
      localStorage.setItem('admin_token', response.data.token);
      
      toast({ 
        title: 'Sucesso!', 
        description: 'Login realizado com sucesso' 
      });
      
      // Call success callback
      if (onLoginSuccess) onLoginSuccess();
      
    } catch (error) {
      console.error('Login error:', error);
      toast({ 
        title: 'Erro', 
        description: error.response?.data?.detail || 'Senha incorreta',
        variant: 'destructive'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-overlay">
      <div className="login-modal">
        <div className="login-header">
          <div className="lock-icon">
            <Lock size={32} />
          </div>
          <h2>Painel de Administração</h2>
          <p>Insira a senha para acessar</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="password-input-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite a senha"
              required
              autoFocus
              className="password-input"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <div className="login-actions">
            <button type="button" onClick={onClose} className="btn-cancel">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="btn-login">
              {loading ? 'Verificando...' : 'Entrar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;